var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ mobile: _vm.isMobileDevice }},[_vm._l((_vm.errorAlerts),function(alert,index){return _c('ErrorAlert',{key:index,attrs:{"title":alert.title,"code":alert.code,"text":alert.text,"close-button":alert.closeButton,"metadata":alert.metadata,"disable-close":alert.disableClose,"disable-click-outside":alert.disableClickOutside,"close":function () {
				_vm.removeAlert(alert.id);
				if (alert.close) {
					alert.close();
				}
			}}})}),_c('NP-Snackbars',{attrs:{"data":_vm.infoAlerts,"close":_vm.removeAlert}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }